/**
 *  @class
 *  @function TextWithIcons
 *  Gestisce l'animazione di ingresso dei blocchi "Text with icons".
 *  Usa GSAP + ScrollTrigger (gia' caricati dal tema) con rivelazione
 *  a cascata e "pop" delle icone, rispettando le preferenze di
 *  riduzione del movimento e adattandosi al breakpoint mobile.
 */

if (!customElements.get('text-with-icons')) {
  class TextWithIcons extends HTMLElement {
    constructor() {
      super();

      this.inner = this.querySelector('.text-with-icons__inner');
      this.blocks = this.querySelectorAll('.text-with-icons__block');
      this.icons = this.querySelectorAll('.text-with-icons__icon');

      // Anima solo se le animazioni del tema sono attive e GSAP e' disponibile.
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }

    prepareAnimations() {
      const section = this;

      // matchMedia: gestisce reduced-motion e adatta i valori al mobile.
      this.mm = gsap.matchMedia();
      this.mm.add(
        {
          reduceMotion: '(prefers-reduced-motion: reduce)',
          isDesktop: '(min-width: 768px)',
          isMobile: '(max-width: 767px)',
        },
        (context) => {
          const { reduceMotion, isMobile } = context.conditions;

          // Utenti con riduzione del movimento: nessuna animazione.
          if (reduceMotion) {
            gsap.set(section.blocks, { opacity: 1, y: 0 });
            gsap.set(section.icons, { opacity: 1, scale: 1 });
            return;
          }

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: section.inner,
              start: 'top 80%',
            },
          });

          tl.from(section.blocks, {
            opacity: 0,
            y: isMobile ? 24 : 40,
            duration: isMobile ? 0.6 : 0.8,
            stagger: isMobile ? 0.08 : 0.12,
            clearProps: 'transform',
          }).from(
            section.icons,
            {
              opacity: 0,
              scale: 0.4,
              duration: 0.6,
              ease: 'back.out(1.7)',
              stagger: isMobile ? 0.08 : 0.12,
            },
            '<0.1'
          );

          // Cleanup quando la condizione smette di essere valida.
          return () => tl.kill();
        }
      );
    }

    disconnectedCallback() {
      // Ripristina lo stato e rimuove gli ScrollTrigger creati.
      if (this.mm) this.mm.revert();
    }
  }

  customElements.define('text-with-icons', TextWithIcons);
}
